import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Popover } from '@mui/material';

import { AppDispatch, closePopover, getPopoverSelector } from '@store';

export const GlobalPopover: FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { anchorElId, content, isOpen } = useSelector(getPopoverSelector);

  const handleClosePopover = () => {
    dispatch(closePopover());
  };

  const anchorEl = anchorElId ? document.getElementById(anchorElId) : null;

  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={handleClosePopover}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      {content}
    </Popover>
  );
};
